import React, { useState } from 'react';
import { ArrowLeft, Pencil } from 'lucide-react';

import { SheetHeader } from '@epoch-ui/components/Sheet/sheet';
import { Button } from '@epoch-ui/components/Button';
import { Avatar, AvatarFallback } from '@epoch-ui/components/Avatar';

import { useGuestSideSheetContext } from '../../guestSideSheetContext';
import { PlusOneGuestModal } from '../../Modals/PlusOneGuestModal/PlusOneGuestModal';

export const PlusOneSideSheetHeader = (): React.ReactNode => {
  const { selectedPlusOneGuest, setSelectedPlusOneId } = useGuestSideSheetContext();
  const plusOneGuest = selectedPlusOneGuest!;

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const goBackToParent = (): void => setSelectedPlusOneId(null);

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <Button
        variant="ghost"
        className="tw-h-6 tw-w-fit tw-p-0 tw-font-normal tw-text-medium-grey hover:tw-bg-transparent"
        onClick={goBackToParent}
      >
        <ArrowLeft size={24} className="tw-mr-1" />
        Back
      </Button>
      <SheetHeader className="tw-flex-row tw-gap-4 tw-space-y-0">
        <Avatar className="tw-h-16 tw-w-16 tw-rounded-3xl">
          <AvatarFallback className="tw-rounded-3xl tw-text-xl tw-font-medium">+1</AvatarFallback>
        </Avatar>
        <div className="tw-flex tw-flex-grow tw-flex-col tw-items-start tw-gap-1">
          <h2 className="tw-m-0 tw-text-xl tw-font-medium tw-leading-7 tw-text-black">
            {plusOneGuest.firstName} {plusOneGuest.lastName}
          </h2>
        </div>
        <Button
          variant="secondary"
          size="xxs"
          className="tw-rounded-xl"
          onClick={() => setIsEditModalOpen(true)}
        >
          <Pencil size={16} className="tw-mr-1" /> Edit
        </Button>
      </SheetHeader>
      <PlusOneGuestModal open={isEditModalOpen} onOpenChange={setIsEditModalOpen} />
    </div>
  );
};
